import { Component, OnInit } from '@angular/core';

import { Router, ActivatedRoute } from '@angular/router';

import { AppStateService } from '../services/app-state.service';
import { AuthService } from '../services/auth.service';

import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import { Observable } from 'rxjs/Observable';

import * as firebase from 'firebase/app';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  /**
   * Set our default values
   */
  public localState = { value: '' };
  public loggedUser = '';
  public isLoginError = false;
  public userIconUrl = '';
  public authCheck = false;

  private userSubscription;
  private auth2: any;
  /**
   * TypeScript public modifiers
   */
  constructor(
    public appState: AppStateService,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute
  ) {
  }

  public ngOnInit() {
    console.log('hello `Home` component');
    // Start loading auth data
    this.authCheck = false;


    this.route.queryParams
      .subscribe(params => {
        this.setLoginError(params['loginError']);
    });

    /**
     * this.title.getData().subscribe(data => this.data = data);
     */
    // Start listeninf for user lagin status change
    this.userSubscription = this.authService.userStream$
    .do(() => {
      this.authCheck = true;
    })
    .subscribe((user) => {
      if (user) {
        this.loggedUser = user.email;
        this.userIconUrl = user.photoURL;
      } else {
        this.loggedUser = 'Anonymus';
      }
    }, (err) => {
      console.log('Check auth failed', err);
    });
  }

  get authDomain() {
    if (this.authService) {
      return this.authService.appDomain;
    } else {
      return '';
    }
  }

  public loginWithGoogle() {
    this.authService.signInWithGoogle();
  }

  public enterTheApp() {
    console.log('Enter the app');
    this.authService.userHasPermission('app.budget')
    .first().toPromise()
    .then((val) => {
      if (val) {
        this.router.navigate(['/budget']);
      } else {
        this.router.navigate(['/timereport']);
      }
    });
  }


  public logingWithFireBase() {
    console.log('fired');
    firebase.auth().signInWithPopup(this.authService.provider).then((result) => {
      // This gives you a Google Access Token. You can use it to access the Google API.
      const token = result.credential.accessToken;
      // The signed-in user info.
      const user = result.user;
      console.log('user', user);
      console.log('token', token);

      // Get the redirect URL from our auth service
      // If no redirect has been set, use the default
      const redirect = this.authService.redirectUrl ? this.authService.redirectUrl : '/budget';
      // Redirect the user
      console.log('Redirecting to...', redirect);
      this.router.navigate([redirect]);
      // ...
    }).catch((error) => {
      // Handle Errors here.
      const errorCode = error.code;
      const errorMessage = error.message;
      console.error(`Error occurred during login: ${errorCode} : ${errorMessage}`);
      this.setLoginError(true);
      // The email of the user's account used.
      const email = error.email;
      // The firebase.auth.AuthCredential type that was used.
      const credential = error.credential;
      // ...
    });
  }

  public logoutWithFireBase() {
    console.log('logoutUser');
    this.authService.logout().then(() => {
      this.router.navigate(['/home']);
    });
  }

  public setLoginError(isError) {
    this.isLoginError = isError == 'true' ? isError : false;
    console.log('ISLOGINERROR', this.isLoginError);
  }

}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts